import { createContext, SetStateAction } from 'react';

export enum AIRolePlayStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum Sender {
  AI = 'AI',
  LEARNER = 'LEARNER',
}

export enum MessageStatus {
  PENDING = 'pending',
  SENT = 'sent',
  FAILED = 'failed',
}
export type Message = {
  content: string;
  sender: Sender;
  createdAt?: Date;
  status?: MessageStatus;
};

export type SessionData = {
  jwtToken: string | null;
  submissionId: number | null;
  expiresAt: string | null;
};

type AiConversationContextType = {
  aiRolePlayStatus: AIRolePlayStatus;
  setAiRolePlayStatus: (value: AIRolePlayStatus) => void;
  showScenarioDetails: boolean;
  setShowScenarioDetails: (value: boolean) => void;
  handleExitChat: () => void;
  aiRolePlayId: number | null;
  messages: Message[];
  setMessages: React.Dispatch<SetStateAction<Message[]>>;
  sessionData: SessionData;
  setSessionData: React.Dispatch<SetStateAction<SessionData>>;
};

const AiConversationContext = createContext<AiConversationContextType>({
  aiRolePlayStatus: AIRolePlayStatus.NOT_STARTED,
  setAiRolePlayStatus: () => {},
  showScenarioDetails: true,
  setShowScenarioDetails: () => {},
  handleExitChat: () => {},
  aiRolePlayId: null,
  messages: [],
  setMessages: () => {},
  sessionData: { jwtToken: null, submissionId: null, expiresAt: null },
  setSessionData: () => {},
});

export default AiConversationContext;
